// Fake user data (not actually storing real card details here lol)

export default {
  firstName: 'Devofficer',
  lastName: 'Irwin',
  email: 'sompaqueen47@gmail.com',
  card: {
    number: '4096',
    expiry: '07/21',
  },
};

export const shareUsers = [
  {
    email: 'nicolina.lindholm@sickvfx.com',
    firstName: 'Nicolina',
    lastName: 'Lindholm',
    seat: '32C',
  },
  {
    email: 'jimmy.mcjimson@sickvfx.com',
    firstName: 'Jimmy',
    lastName: 'McJimson',
    seat: '',
  },
  {
    email: 'john.davidson@sickvfx.com',
    firstName: 'John',
    lastName: 'Davidson',
    seat: '61E',
  },
  {
    email: 'serana.jones@sickvfx.com',
    firstName: 'Serana',
    lastName: 'Jones',
    seat: '68A',
  },
  {
    email: 'andy.mckenty@sickvfx.com',
    firstName: 'Andy',
    lastName: 'McKenty',
    seat: '',
  },
];
